'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent, useState } from 'react';
import type { SessionConnection, SessionFeedProps } from './types';
import { useRealtime } from '@/lib/hooks/use-realtime';
import { REALTIME_KEYS } from '@/lib/realtime/types';
export function CloudSessionFeed(t0) {
  const $ = _c(31);
  const {
    sessionId,
    controller,
    receive
  } = t0;
  const [joinedSession, setJoinedSession] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => setJoinedSession(null);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== sessionId) {
    t2 = [sessionId];
    $[1] = sessionId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  const [online, setOnline] = useState(_temp);
  let t3;
  if ($[3] !== receive) {
    t3 = t4 => {
      const {
        events
      } = t4;
      receive(events ?? []);
    };
    $[3] = receive;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== controller || $[6] !== sessionId) {
    t4 = () => {
      setJoinedSession(sessionId);
      controller.subscribed();
    };
    $[5] = controller;
    $[6] = sessionId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setJoinedSession(null);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== controller) {
    t6 = () => {
      controller.refresh();
    };
    $[9] = controller;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== sessionId || $[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = {
      eventKey: REALTIME_KEYS.CODE_SESSION_EVENT,
      id: sessionId,
      dedicatedSocket: true,
      onEvent: t3,
      onSubscribed: t4,
      onDisconnected: t5,
      onError: t6
    };
    $[11] = sessionId;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const channel = useRealtime(t7);
  let t8;
  if ($[16] !== channel) {
    t8 = () => {
      setJoinedSession(null);
      channel.reconnect();
    };
    $[16] = channel;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const rejoin = t8;
  let t9;
  if ($[18] !== rejoin) {
    t9 = isOnline => {
      setOnline(isOnline);
      rejoin();
    };
    $[18] = rejoin;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const onNetworkChange = useEffectEvent(t9);
  let t10;
  if ($[20] !== onNetworkChange) {
    t10 = () => {
      const reconnect = () => onNetworkChange(true);
      const disconnect = () => onNetworkChange(false);
      window.addEventListener("online", reconnect);
      window.addEventListener("offline", disconnect);
      return () => {
        window.removeEventListener("online", reconnect);
        window.removeEventListener("offline", disconnect);
      };
    };
    $[20] = onNetworkChange;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [];
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  useEffect(t10, t11);
  const connection = joinedSession === sessionId ? "live" : online ? "reconnecting" : "offline";
  let t12;
  if ($[23] !== controller || $[24] !== rejoin) {
    t12 = () => {
      rejoin();
      controller.refresh();
    };
    $[23] = controller;
    $[24] = rejoin;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const retry = t12;
  let t13;
  let t14;
  if ($[26] !== connection || $[27] !== controller || $[28] !== retry) {
    t13 = () => {
      controller.reportConnection(connection, retry);
    };
    t14 = [connection, controller, retry];
    $[26] = connection;
    $[27] = controller;
    $[28] = retry;
    $[29] = t13;
    $[30] = t14;
  } else {
    t13 = $[29];
    t14 = $[30];
  }
  useEffect(t13, t14);
  return null;
}
function _temp() {
  return typeof navigator === "undefined" || navigator.onLine;
}